import { ErrorActorEvent, NonReducibleUnknown, sendParent } from 'xstate';
import { ActionEventParams, ActorErrorParams } from '../../../../lib/types';
import { SendChildMachineReady } from '../../types/events';
import { FraudAlloyContext } from './fraudAlloyMachine';
import {
  InitializingFraudAlloyResult,
  StartIDUploadJourneyResult,
} from './types/actors';
import {
  FraudAlloyMachineEvents,
  SendIDUploadJourneyFailure,
  SendIDUploadJourneySuccess,
  SendInitializeFraudAlloyActorDone,
  SendStartIDUploadJourneyActorDone,
} from './types/events';

/**
 * Gets InitializingFraudAlloyResult from initializeFraudAlloy SendInitializeFraudAlloyActorDone
 * @param ActionEventParams<FraudAlloyContext, SendInitializeFraudAlloyActorDone>
 * @returns InitializingFraudAlloyResult
 */
export const getInitializeFraudAlloyParams = ({
  event,
}: ActionEventParams<
  FraudAlloyContext,
  SendInitializeFraudAlloyActorDone
>): InitializingFraudAlloyResult => {
  return event.output;
};

/**
 * Gets StartIDUploadJourneyResult from startIDUploadJourney
 * @param ActionEventParams<FraudAlloyContext, SendStartIDUploadJourneyActorDone>
 * @returns StartIDUploadJourneyResult
 */
export const getStartIDUploadJourney = ({
  event,
}: ActionEventParams<
  FraudAlloyContext,
  SendStartIDUploadJourneyActorDone
>): StartIDUploadJourneyResult => {
  return event.output;
};

/**
 * Gets ActorErrorParams from error event
 * @param ActionEventParams<FraudAlloyMachineEvents, ErrorActorEvent>
 * @returns ActorErrorParams
 */
export const getServiceErrorParams = ({
  event,
}: ActionEventParams<FraudAlloyContext, ErrorActorEvent>): ActorErrorParams => {
  const errorOutput = event.error as ActorErrorParams;

  return {
    type: event.type,
    error: errorOutput,
    reject: errorOutput.reject,
  };
};

/**
 * Sends IDUploadJourney success event to parent
   @returns SendCreateVirtualCardIssuanceSuccess
 */
export const emitIDUploadJourneySuccess = sendParent<
  FraudAlloyContext,
  FraudAlloyMachineEvents,
  NonReducibleUnknown,
  SendIDUploadJourneySuccess,
  FraudAlloyMachineEvents,
  never,
  never
>(() => ({
  type: 'SEND_ID_UPLOAD_JOURNEY_SUCCESS',
}));

/**
 * Sends IDUploadJourney success event to parent
   @returns SendCreateVirtualCardIssuanceSuccess
 */
export const emitIDUploadJourneyFailure = sendParent<
  FraudAlloyContext,
  FraudAlloyMachineEvents,
  NonReducibleUnknown,
  SendIDUploadJourneyFailure,
  FraudAlloyMachineEvents,
  never,
  never
>(() => ({
  type: 'SEND_ID_UPLOAD_JOURNEY_FAILURE',
}));

/**
 * Sends create virtual card issuance attempting event to parent
   @returns SendCreateVirtualCardIssuanceAttempting
 */
export const emitFraudAlloyMachineReady = sendParent<
  FraudAlloyContext,
  FraudAlloyMachineEvents,
  NonReducibleUnknown,
  SendChildMachineReady,
  FraudAlloyMachineEvents,
  never,
  never
>(() => {
  return {
    type: 'SEND_CHILD_MACHINE_READY',
    params: {
      machineId: 'fraudAlloyMachine',
    },
  };
});
